import { useMedia } from 'react-use';
import useDeviceContext from '@sls-react/contexts/DeviceContext';

export default function useMobile() {
  const deviceContext = useDeviceContext();
  // default to mobile
  return useMedia('(max-width: 767px)', deviceContext === 'mobile');
}
